import { trackEvent } from 'components/main/main.component'
import React, { FC, useEffect, useRef, useState } from 'react'
import styled from 'styled-components'
const isMobile = window.innerWidth < 712

const buttonHeight = 60
const StyledAccordion = styled.div<{ height: number }>`
  display: inline-block;
  max-height: ${({ height }) => height + 30 + 'px'};
  /* padding-bottom: 90px; */
  width: 100%;
  position: relative;
  transition: max-height 0.15s linear, min-height 0.15s linear;
`

const ContentContainer = styled.div<{ height: number; open: boolean }>`
  pointer-events: ${({ open }) => (open ? 'all' : 'none')};
  max-height: ${({ height }) => height + 'px'};
  min-height: ${({ height }) => height + 'px'};
  overflow: ${({ open }) => (open ? 'visible' : 'hidden')};
  width: 100%;
  transition: max-height 0.15s linear, min-height 0.15s linear;
`

const Button = styled.button<{ light: boolean }>`
  background-color: ${({ light }) =>
    light ? 'var(--brandblue-bright-5)' : 'var(--brandblue-main)'};
  font-family: var(--font-plex);
  border: 0;
  position: absolute;
  bottom: 0px;
  left: 50%;
  height: ${buttonHeight}px;
  min-width: ${isMobile ? '100%' : '300px'};
  transform: translateX(-50%);
  font-size: 15px;
  letter-spacing: 1px;
  padding: 0.1em 1em;
  color: ${({ light }) => (light ? 'var(--brandblue-main)' : 'white')};
  &:hover {
    cursor: pointer;
    background-color: ${isMobile ? undefined : 'var(--brandblue-bright-3)'};
  }
`
const GradientOverlay = styled.div`
  height: ${buttonHeight + 20}px;
  position: absolute;
  left: 0;
  bottom: ${buttonHeight + 20}px;
  width: 100%;
  background: rgb(255, 255, 255);
  background: linear-gradient(
    0deg,
    rgba(255, 255, 255, 1) 5%,
    rgba(248, 247, 244, 0) 100%
  );
  /* border-bottom: 1px solid var(--brandblue-bright-5); */
`
const ButtonBackground = styled.div`
  position: absolute;
  left: 0;
  bottom: 0px;
  width: 100%;
  display: inline-block;
  height: ${buttonHeight + 20}px;
  background-color: white;
`

const ContentHeight = styled.div``
export const Accordion: FC<{
  labels: (string | string[])[]
  heightClosed?: number
  handleClose?: () => void
  scrollOnClose?: boolean
  lightButton?: boolean
  data?: any[]
}> = ({
  children,
  labels,
  heightClosed = 0,
  scrollOnClose = true,
  handleClose,
  lightButton = false,
  data
}) => {
  heightClosed = heightClosed + 40
  const [open, setOpen] = useState(false)
  const [contentHeight, setContentHeight] = useState<number>(400)
  const container = useRef<HTMLDivElement>(null)
  const AccRef = useRef<HTMLDivElement>(null)
  useEffect(() => {
    if (!container.current) return
    setContentHeight(container.current.clientHeight + buttonHeight + 20)
  }, [container.current, open, data])

  return (
    <StyledAccordion
      className='Accordion'
      height={open ? contentHeight : heightClosed}
      ref={AccRef}
    >
      <ContentContainer
        className='ContentContainer'
        height={open ? contentHeight : heightClosed}
        open={open}
      >
        <ContentHeight ref={container}> {children && children}</ContentHeight>
        {!open && heightClosed > 40 && (
          <GradientOverlay className='GradientOverlay' />
        )}
        <ButtonBackground />
      </ContentContainer>

      <Button
        light={lightButton}
        onClick={() => {
          if (AccRef.current && open && scrollOnClose) {
            AccRef.current.scrollIntoView({ behavior: 'auto' })
          }
          if (open) {
            if (handleClose) handleClose()
          }
          trackEvent({
            event_label: !open ? 'accordion open' : 'accordion close'
          })
          setOpen(!open)
        }}
      >
        {open ? labels[1] : labels[0]}
      </Button>
    </StyledAccordion>
  )
}
